import { IFormRegister } from 'routes/Main/type';

import Form from 'components/Form';

import { Box, Table, TableBody, TableRow } from '@mui/material';

import {
  StyledTableCell,
  StyledTableCellWithoutLeft,
  StyledTableCellWithoutLeftRight,
} from 'routes/Main/style';

interface Props extends IFormRegister {
  disabled?: boolean;
}

const Signature = (props: Props) => {
  const { disabled, register } = props;

  const labels = [{ title: '날짜', variable: 'date' }];

  return (
    <>
      <Box sx={{ width: '100%', margin: '10px auto 0px auto' }}>
        <Table aria-label="simple table">
          <TableBody>
            <TableRow>
              <StyledTableCell
                align="center"
                sx={{
                  padding: '50px',
                  width: '200px',
                  fontSize: '12px',
                  border: 'none',
                }}
              ></StyledTableCell>
              <StyledTableCellWithoutLeftRight sx={{ border: 'none' }}>
                <div style={{ display: 'flex', margin: '20px 0 20px 0' }}>
                  <Box
                    sx={{
                      paddingTop: '10px',
                      paddingLeft: '10px',
                      fontSize: '12px',
                      border: 'none',
                      width: '150%',
                    }}
                  ></Box>
                  <Box
                    sx={{
                      paddingTop: '10px',
                      paddingLeft: '10px',
                      fontSize: '12px',
                      border: 'none',
                      width: '150%',
                    }}
                  ></Box>

                  <Box
                    sx={{
                      paddingTop: '10px',
                      paddingLeft: '30px',
                      fontSize: '12px',
                      minWidth: '150px',
                      border: 'none',
                    }}
                  >
                    날짜
                  </Box>
                  <Form.MuiTextField
                    type="date"
                    sx={{ paddingRight: '10px' }}
                    required={false}
                    disabled={disabled}
                    {...register('date')}
                  />
                </div>
              </StyledTableCellWithoutLeftRight>
              <StyledTableCellWithoutLeft
                sx={{ border: 'none' }}
              ></StyledTableCellWithoutLeft>
            </TableRow>
          </TableBody>
        </Table>
      </Box>
      <Box sx={{ width: '100%', margin: '0px auto 30px auto' }}>
        <Table aria-label="simple table">
          <TableBody>
            <TableRow>
              <StyledTableCell
                align="center"
                sx={{ padding: '30px', width: '200px', fontSize: '12px' }}
              >
                서명자
              </StyledTableCell>
              <StyledTableCellWithoutLeftRight>
                <div style={{ display: 'flex', margin: '20px 0 20px 0' }}>
                  <Box
                    sx={{
                      paddingTop: '10px',
                      paddingLeft: '10px',
                      minWidth: '130px',
                      fontSize: '12px',
                    }}
                  >
                    환자와의 관계
                  </Box>
                  <Form.MuiTextField
                    required={false}
                    disabled={disabled}
                    {...register('consenter_relationship')}
                  />
                  <Box
                    sx={{
                      paddingTop: '10px',
                      paddingLeft: '10px',
                      fontSize: '12px',
                      minWidth: '130px',
                    }}
                  >
                    성명
                  </Box>
                  <Form.MuiTextField
                    sx={{ paddingRight: '10px' }}
                    required={false}
                    disabled={disabled}
                    {...register('consenter_name')}
                  />
                  <Box
                    sx={{
                      paddingTop: '10px',
                      paddingLeft: '10px',
                      fontSize: '12px',
                      minWidth: '130px',
                    }}
                  >
                    서명 또는 인
                  </Box>
                  <Form.MuiTextField
                    sx={{ paddingRight: '10px' }}
                    required={false}
                    disabled={disabled}
                    {...register('consenter_sig')}
                  />
                </div>
              </StyledTableCellWithoutLeftRight>
              <StyledTableCellWithoutLeft></StyledTableCellWithoutLeft>
            </TableRow>

            <TableRow>
              <StyledTableCell
                align="center"
                sx={{ padding: '30px', width: '150px', fontSize: '12px' }}
              >
                입증인
              </StyledTableCell>
              <StyledTableCellWithoutLeftRight>
                <div style={{ display: 'flex', margin: '20px 0 20px 0' }}>
                  <Box
                    sx={{
                      paddingTop: '10px',
                      paddingLeft: '10px',
                      minWidth: '130px',
                      fontSize: '12px',
                    }}
                  >
                    직위
                  </Box>
                  <Form.MuiTextField
                    required={false}
                    disabled={disabled}
                    {...register('attestor_spot')}
                  />
                  <Box
                    sx={{
                      paddingTop: '10px',
                      paddingLeft: '10px',
                      fontSize: '12px',
                      minWidth: '130px',
                    }}
                  >
                    성명
                  </Box>
                  <Form.MuiTextField
                    sx={{ paddingRight: '10px' }}
                    required={false}
                    disabled={disabled}
                    {...register('attestor_name')}
                  />
                  <Box
                    sx={{
                      paddingTop: '10px',
                      paddingLeft: '10px',
                      fontSize: '12px',
                      minWidth: '130px',
                    }}
                  >
                    서명 또는 인
                  </Box>
                  <Form.MuiTextField
                    sx={{ paddingRight: '10px' }}
                    required={false}
                    disabled={disabled}
                    {...register('attestor_sig')}
                  />
                </div>
              </StyledTableCellWithoutLeftRight>
              <StyledTableCellWithoutLeft></StyledTableCellWithoutLeft>
            </TableRow>
          </TableBody>
        </Table>
      </Box>
    </>
  );
};

export default Signature;
